import React from 'react'

const IuppContactList = (props) => {
  return (
    <div className='col-12 px-0 py-3 contact-list'>
      <h3 title='fale com a gente' tabIndex={0}>
        fale com a gente
      </h3>
      <ul className='flexible-items-container'>
        <li className='flex-item' title='capitais e regiões metropolitanas' tabIndex={0}>
          capitais e regiões metropolitanas
          <span title='4090- 1675' tabIndex={0}>4090- 1675</span>
        </li>
        <li className='flex-item' title='demais regiões' tabIndex={0}>
          demais regiões
          <span title='0800 775 1675' tabIndex={0}>0800 775 1675</span>
        </li>
        <li className='flex-item' title='SAC iupp' tabIndex={0}>
          SAC iupp
          <span tabIndex={0} title='0800 770 2575'>0800 770 2575</span>
        </li>
        <li className='flex-item' title='e-mail' tabIndex={0}>
          e-mail
          <a title='ajuda@iupp.com.br' href='mailto:ajuda@iupp.com.br' tabIndex={0}>ajuda@iupp.com.br</a>
        </li>
      </ul>
    </div>
  )
}

export default IuppContactList



// WEBPACK FOOTER //
// ./src/App/Footer/IuppContactList.js